import { Link } from "@remix-run/react";

import { getLocalizedPagePath } from "~/helpers/navigationHelper";

type BreadcrumbProps = {
  title: string;
  page: string;
  backgroundImg: string;
  parent: string;
  parentLink?: string;
};

export default function Breadcrumb({
  title,
  page,
  backgroundImg,
  parent,
  parentLink,
}: BreadcrumbProps) {
  return (
    <div
      className="cs-page_heading cs-style1 cs-center text-center"
      style={{ backgroundImage: `url('${backgroundImg}')` }}
    >
      <div className="container">
        <div className="cs-page_heading_in">
          <h1 className="cs-page_title cs-font_50 cs-white_color">{title}</h1>
          <ol className="breadcrumb text-uppercase">
            <li className="breadcrumb-item">
              <Link to={parentLink || getLocalizedPagePath("")}>{parent}</Link>
            </li>
            <li className="breadcrumb-item active">{page}</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
